<template>
    <div>
        <navbar></navbar>
        <section class="hero">
            <div class="hero-body">
                <div class="container">
                    <form @submit.prevent="searchClick">
                        <div class="field has-addons">
                            <p class="control">
                                <a class="button is-info" @click="clearSearch">Clear</a>
                            </p>
                            <div class="control stretch">
                                <input class="input" type="text" placeholder="Search Burial Records" v-model="term">
                            </div>
                            <div class="control">
                                <a class="button is-info" v-bind:class="{'is-loading': loading}" @click="searchClick">
                                    Search
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
        <section v-if="this.results.length" class="section">
            <div class="container">
                <div class="columns">
                    <div class="column is-full">
                        <div class="field">
                            <div>
                                <p class="control">
                                    <button class="button is-info"  @click="clearSorts">Clear Sorts</button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section v-if="this.results.length" class="section">
            <div class="container">
                <div class="columns">
                    <div v-if="!this.loading" class="column is-full records-table">
                        <table class="table is-hoverable">
                            <thead>
                            <tr class="is-bordered">
                                <th @click="sort('last_name')">Last Name</th>
                                <th @click="sort('first_name')">First Name</th>
                                <th @click="sort('date_of_death')">Date of Death</th>
                                <th @click="sort('burial_number')">Burial Number</th>
                                <th @click="sort('section_name')">Section</th>
                                <th @click="sort('lot')">Lot</th>
                                <th @click="sort('space')">Space</th>
                                <th @click="sort('tier')">Tier</th>
                            </tr>
                            </thead>
                            <tbody v-if="!this.loading">
                            <tr v-for="row in this.sortedResults" v-bind:key="row.id" @click="selected(row)">
                                <td>{{row.last_name}}</td>
                                <td>{{row.first_name}}</td>
                                <td>{{row.date_of_death}}</td>
                                <td>{{row.burial_number}}</td>
                                <td>{{row.section_name}}</td>
                                <td>{{row.lot}}</td>
                                <td>{{row.space}}</td>
                                <td>{{row.tier}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else-if="this.loading" class="column is-full records-table">
                        <Loader></Loader>
                    </div>
                    <div v-else class="column is-full is-size-5 is-pulled-left">Something went wrong.</div>
                </div>
            </div>
        </section>
        <section v-if="!this.results.length && !this.first_loaded" class="section">
            <div class="container">
                <div class="columns">
                    <div class="column is-full">
                        <h1>No Search results found</h1>
                    </div>
                </div>
            </div>
        </section>
        <section v-if="this.results.length" class="section">
            <div class="container">
                <div class="columns">
                    <div class="column is-full">
                        <nav class="pagination is-right" role="navigation" aria-label="pagination">
                            <button v-show="this.page > 1" class="button pagination-next" @click="prevPage()">Previous</button>
                            <button class="button pagination-next" @click="nextPage()">Next page</button>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Navbar from "../components/Navbar";
    import Result from "../components/Result";
    import Loader from "../components/Loader";

    export default {
        name: "dashboard",
        components: {Navbar,Result,Loader},
        data() {
            return {
                term: "",
                results: [],
                page: 1,
                first_loaded: true,
                loading: false,
                sorts: []
            }
        },
        computed:{
            sortedResults:function() {
                return this.results.sort((a,b) => {
                    let modifier = 1;
                    if(this.currentSortDir === 'desc') modifier = -1;
                    if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                });
            }
        },
        methods: {
            clearSearch(){
                this.term = '';
            },
            searchClick() {
                this.page = 1;
                this.search();
            },
            search() {
                this.loading = true;
                let url = process.env.VUE_APP_API;
                url = url + '/search/';
                let search = this.term;
                let location = this.$store.getters.default_location_id;
                this.$http.post(url, {
                    data: {
                        term: search,
                        location_id: location,
                        page_number: this.page,
                        sorts: this.sorts
                    }
                })
                    .then(response => {
                        this.results = response.data.data;
                        this.first_loaded = false;
                        this.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        this.loading = false;
                    });
            },
            nextPage() {
                this.page++;
                this.search();
            },
            prevPage() {
                this.page--;
                this.search();
            },
            selected(item) {
                let path = '/record/' + item.id;
                this.$router.push({path: path});
            },
            sort(s){
                let index = -1;
                index = this.sorts.indexOf(s);
                if(index == -1)
                {
                    index = this.sorts.indexOf('-'+s);
                    if(index == -1)
                    {
                        this.sorts.push(s);
                    }
                    else
                    {
                        this.sorts[index] = s;
                    }
                }
                else
                {
                    this.sorts[index] = ('-'+s);
                }
                this.search();
            },
            clearSorts()
            {
                this.sorts = [];
                this.search();
            }
        }
    }
</script>

<style scoped>
    .stretch {
        width: 100%;
        max-width: 600px;
    }

    .field.has-addons {
        justify-content: center;
    }
    table tr th:hover{
        background: hsl(217, 71%, 53%, 0.7);
        border-radius: 4px;
        color: #fff;
    }

    .table {
        margin-left: auto;
        margin-right: auto;
        width: 100%;
    }
</style>